import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import minMax from 'dayjs/plugin/minMax';

// Extend dayjs with plugins
dayjs.extend(isBetween);
dayjs.extend(localizedFormat);
dayjs.extend(minMax);

export default dayjs;
